export default {
  typeOptions: {
    NP: 'Natural person',
    LP: 'Legal person'
  },
  NP: {
    type: 'Legal entity',
    residence: 'Residency type',
    name: 'Name',
    tradeName: 'First surname',
    lastName: 'Second surname',
    document: 'VAT Number',
    street: 'Address',
    postalCode: 'Postcode',
    town: 'Town',
    city: 'City',
    country: 'Country',
    accountingOffice: 'Accounting office',
    managerBody: 'Manager body code',
    processingUnit: 'Processing unit',
    proponentBody: 'Proponent body',
    contactMedium: 'Contact information',
    additionalInfo: 'Additional information claimed by the payer',
    contractReference: 'Contract reference',
    mercantileRegistry: 'Mercantile registry',
    Dir3Data: {
      code: 'Code',
      description: 'Description',
      postalCode: 'Postcode',
      address: 'Address',
      city: 'City',
      region: 'Region',
      country: 'Country',
      name: 'Name',
      firstName: 'First surname',
      lastName: 'Second surname'
    }
  },
  LP: {
    type: 'Legal entity',
    residence: 'Residency type',
    name: 'Business name',
    tradeName: 'Trade name',
    lastName: 'Last name',
    document: 'VAT Number',
    street: 'Address',
    postalCode: 'Post code',
    town: 'Town',
    city: 'City',
    country: 'Country',
    accountingOffice: 'Accounting office',
    Dir3Data: {
      code: 'Code',
      description: 'Description',
      postalCode: 'Postcode',
      address: 'Address',
      city: 'City',
      region: 'State',
      country: 'Country',
      name: 'Name',
      firstName: 'First surname',
      lastName: 'Second surname'
    },
    managerBody: 'Manager body code',
    processingUnit: 'Processing unit',
    proponentBody: 'Proponent body',
    contactMedium: 'Contact information',
    additionalInfo: 'Additional information claimed by the payer',
    contractReference: 'Contract reference',
    mercantileRegistry: 'Mercantile registry',
    FACeB2B: {
      sectionTitle: 'FACeB2B data',
      code: 'Receiver code',
      name: 'Name',
      publicOrganismCode: 'Organism Code',
      contractReference: 'Contract Reference'
    }
  },
  FC: {
    residence: 'Residency type',
    corporateName: 'Business name',
    tradeName: 'Trade name',
    document: 'VAT Number',
    address: 'Address',
    street: 'Street',
    postalCode: 'Postcode',
    town: 'Town',
    city: 'City',
    country: 'Country',
    book: 'Book',
    folio: 'Folio',
    sheet: 'Sheet',
    section: 'Section',
    volume: 'Volume',
    mercantileRegistry: 'Mercantile registry',
    additionalRegistrationData: 'Additional data',
    medium: 'Additional data',
    email: 'Email',
    fax: 'Fax',
    phone: 'Telephone',
    web: 'Website',
    name: 'Contact person',
    additionalContactDetails: 'Additional data'
  },
  riojaAgendaMessage: 'It is recommended to add the contact from the agenda and searching by the manager code, rather than adding it manually.'
}
